"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supply_rule_edit_schema = exports.supply_rule_schema = exports.supply_rule_state_schema = exports.SupplyRuleState = void 0;
const zod_1 = require("zod");
const criterias_1 = require("./criterias");
exports.SupplyRuleState = {
    Active: "active",
    Disabled: "disabled"
};
exports.supply_rule_state_schema = zod_1.z.nativeEnum(exports.SupplyRuleState);
exports.supply_rule_schema = zod_1.z.object({
    id: zod_1.z.number(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    state: exports.supply_rule_state_schema,
    /** Date in format YYYY-MM-DDTHH:mm:ssZ */
    created_at: zod_1.z.string(),
    /** Date in format YYYY-MM-DDTHH:mm:ssZ */
    updated_at: zod_1.z.string(),
    /** Defines under what situation a rule is applied */
    triggers: zod_1.z.array(criterias_1.supply_rule_criteria_schema),
    /** Defines under what situation a trip is filtered out */
    criterias: zod_1.z.array(criterias_1.supply_rule_criteria_schema)
});
exports.supply_rule_edit_schema = zod_1.z.object({
    rule_id: zod_1.z.number(),
    previous_name: zod_1.z.string(),
    previous_description: zod_1.z.string(),
    previous_state: exports.supply_rule_state_schema,
    previous_triggers: zod_1.z.array(criterias_1.supply_rule_criteria_schema),
    previous_criterias: zod_1.z.array(criterias_1.supply_rule_criteria_schema),
    /** Date in format YYYY-MM-DDTHH:mm:ssZ */
    updated_at: zod_1.z.string(),
    /** Email of the author of the latest version (the one who overwrote the "previous" rule) */
    updated_author: zod_1.z.string()
});
//# sourceMappingURL=rules.js.map